import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';

class Usage extends ChemComponent {
	constructor(props) {
		super(props);

		// start with from date of 3 years ago
		var from3Years = new Date();
		from3Years.setFullYear(from3Years.getFullYear() - 3);
		
		var search = {
			ORDER_FROM: this.dateTimeToMVC(from3Years),
			ORDER_TO: null,
			ORDER_BY: ['USER_NAME']
		};
		
		var usageListInit = this.copyTable(usageList);
		usageListInit.ajax.data = {
			search: search
		};

		this.state = {
			search: search,
			usageSearch: this.copyColumns(usageSearch),
			usageList: usageListInit,
			searchCount: null,
			renderKey: 0
		};
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}

	onSubmitSearch(event, newOrderBy) {
		// copy search in case we need to incorporate the new ordering
		var search = this.copyObject(this.state.search);
		if (newOrderBy) search.ORDER_BY = newOrderBy;
		var newUsageList = this.copyTable(usageList);
		newUsageList.ajax.data = { search: this.copyObject(search) };
		
		this.mergeState({
			search: search,
			usageList: newUsageList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
	}
	
	onSearchResult(data) {		
		this.mergeState({
			searchCount: data.ResultCount,
		});
	}
	
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			Action: 'Usage',
			columns: exportColumns,
			search: this.state.search
		});			
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Requests</div>
						<ChemEdit parent={this} user={this.props.user} columns={this.state.usageSearch} data={this.state.search}
						  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Reuse/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Reuse/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Reuse_Usage' table={this.state.usageList}
				    order={this.state.search.ORDER_BY} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='195px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const usageSearch = [
	{ Header: 'Ordered From', accessor: 'ORDER_FROM', type: 'date', row: 0, col: 0 },
	{ Header: 'Ordered To', accessor: 'ORDER_TO', type: 'date', row: 0, col: 1 },
];

const usageList = {
	ajax: { 
		url: '/Reuse/UsageReport',
		data: null,
		accessor: 'Data'
	},
	pageSize: 20,
	columns: [
		{ Header: 'Customer', accessor: 'USER_NAME', width: 250 },
		{ Header: 'PI', accessor: 'PI_NAME', width: 250,
			Cell: props => props.parent.getCellFragment(props.value) },
		{ Header: 'Supervisor', accessor: 'SUP_NAME', width: 250,
			Cell: props => props.parent.getCellFragment(props.value) },
		{ Header: 'Orders', accessor: 'ORDER_COUNT', width: 80 },
		{ Header: 'Items', accessor: 'ITEM_COUNT', width: 80 },
	]
};

const exportColumns = [
	{ Header: 'Customer', accessor: 'USER_NAME', width: 50 },
	{ Header: 'PI', accessor: 'PI_NAME', width: 50 },
	{ Header: 'Supervisor', accessor: 'SUP_NAME', width: 50 },
	{ Header: 'Orders', accessor: 'ORDER_COUNT', width: 16 },
	{ Header: 'Items', accessor: 'ITEM_COUNT', width: 16 },
];

export default withRouter(Usage);
